import {
  Antrag,
  EinreichungComponentType,
  EinreichungStep,
  EinreichungStepResultType,
} from '@ebeihilfe/einreichung-old';
import { AntragModalComponent } from '../antrag-modal/antrag-modal.component';
import {
  AntragsType,
  Deferred,
  EinreichungComponents,
  MessageBase,
  Stammdaten,
  StammdatenService,
} from '@ebeihilfe/core';
import { Component } from '@angular/core';
import { LegacyAntragsMetadata } from '@eBeihilfe/einreichung-shared/model';
import { ModalService, OverlayService } from '@ebeihilfe/web-logic';
import { marker as _ } from '@colsen1991/ngx-translate-extract-marker';

// eslint-disable-next-line @angular-eslint/prefer-on-push-component-change-detection
@Component({
  selector: 'portal-einreichung-kurzantrag',
  templateUrl: './kurzantrag.component.html',
  standalone: false,
})
export class KurzantragComponent implements EinreichungComponentType {
  public name = EinreichungComponents.Kurzantrag;
  public readonly component = KurzantragComponent;
  public readonly prio = EinreichungStep.INIT + 3;

  private antrag: Antrag;
  private work: Deferred<EinreichungStepResultType>;

  constructor(
    private readonly message: MessageBase,
    private readonly modals: ModalService,
    private readonly spinnerService: OverlayService,
    private readonly stammdatenService: StammdatenService,
  ) {}

  public canHandle(antrag: Antrag): boolean | Promise<boolean> {
    return !antrag.hasAntragsMetadata();
  }

  public destroy(): Promise<void> {
    return Promise.resolve();
  }

  public handle(
    antrag: Antrag,
    instance: KurzantragComponent,
    work: Deferred<EinreichungStepResultType>,
  ): Promise<EinreichungStepResultType> {
    instance.antrag = antrag;
    instance.work = work;

    instance.prepareAndShowKurzantragModal();

    return instance.work;
  }

  public hasUi(): boolean {
    return true;
  }

  public async prepareAndShowKurzantragModal(): Promise<void> {
    this.spinnerService.show();

    try {
      const stammdaten = await this.stammdatenService.getStammdaten();
      this.spinnerService.hide();
      if (!stammdaten) {
        return;
      }

      const kurzAntragData = await this.presentKurzantragDialog(stammdaten);
      if (!kurzAntragData) {
        return;
      }

      this.antrag.setAntragsType(kurzAntragData.type);
      this.antrag.setAntragsData(kurzAntragData.data);

      this.work.resolve({
        result: this.antrag,
        shouldProceed: true,
      });
      return;
    } catch (ex) {
      if (ex.message !== 'pin not available') {
        await this.message.showError({
          message: _('view_finished_antrag.text.encryption_error'),
        });
      }
      return;
    } finally {
      this.spinnerService.hide();
    }
  }

  private presentKurzantragDialog(
    stammdaten: Stammdaten,
  ): Promise<{ data: LegacyAntragsMetadata[]; type: AntragsType }> {
    return this.modals.openModal<
      AntragModalComponent,
      { data: LegacyAntragsMetadata[]; type: AntragsType },
      Stammdaten
    >(AntragModalComponent, stammdaten);
  }
}
